import { useParams } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import { Message } from "primereact/message";
import { Breadcrumb, PageHeader } from "../../components/ui";
import { useGetBenefitPartnerByIdQuery } from "../../store/services/benefits";
import { BenefitPartnerForm } from "../../components/Forms/BenefitPartnerForm";

export const EditBenefitPartner = () => {
  const { id } = useParams();
  const { data, isLoading, isError } = useGetBenefitPartnerByIdQuery(id || "", { skip: !id });

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Partners", to: "/benefits-partners" },
          { label: data?.name ?? "Partner", to: id ? `/benefits-partners/${id}` : undefined },
          { label: "Editar" },
        ]}
      />
    <div className="p-card gap-4 p-3">
      <PageHeader title="Editar Partner" />
      {isLoading ? (
        <div className="flex flex-column justify-content-center align-items-center gap-4 p-8">
          <ProgressSpinner />
        </div>
      ) : isError || !data ? (
        <div className="flex justify-content-center p-4">
          <Message
            severity="error"
            text="No se pudo cargar el partner. Intentá de nuevo en unos minutos."
          />
        </div>
      ) : (
        <BenefitPartnerForm partnerData={data} />
      )}
    </div>
    </>
  );
};
